import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { generatePath, Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { canUserShare, getIsPlaylistEditable, hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import { getContentChangelogUrl } from 'utils/asset/getContentChangelogUrl';
import createLocation from 'utils/createLocation';
import { useDuplicatePlaylists, useDeletePlaylist } from 'actions/playlists';
import { useRestoreContent } from 'actions/content';
import { NavMenu, NavMenuButton, NavMenuList, NavMenuItem, NavMenuDivider } from 'components/NavMenu';
import useBreakpoints from 'hooks/useBreakpoints';
import useModalQueryParam from 'hooks/useModalQueryParam';
import useSearchParams from 'hooks/useSearchParams';
import { useAppNameContext } from 'hooks/useAppNameContext';
import PlaylistDeleteModal from 'screens/PlaylistDeleteModal';
import ShareContentModal from 'screens/ShareModal';
import CopyContentLinkModal from 'screens/CopyContentLinkModal';
import { getPlaylistPageNumber } from 'utils/playlist/getPlaylistPageNumber';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ChangelogOption(_ref) {
  var contentId = _ref.contentId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var appNameContext = useAppNameContext();
  var changelogUrl = getContentChangelogUrl({
    contentId: contentId,
    withAdminBasePath: appNameContext === 'hub'
  });
  if (appNameContext === 'admin') {
    return /*#__PURE__*/_jsx(NavMenuItem, {
      as: Link,
      to: changelogUrl,
      children: t('property_changelog')
    });
  } else {
    return /*#__PURE__*/_jsx(NavMenuItem, {
      as: "a",
      href: changelogUrl,
      target: "_blank",
      children: t('property_changelog')
    });
  }
}
export function ShareContentOption(_ref2) {
  var shareData = _ref2.shareData,
    _ref2$modalQueryParam = _ref2.modalQueryParam,
    modalQueryParam = _ref2$modalQueryParam === void 0 ? 'share-playlist' : _ref2$modalQueryParam;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useModalQueryParam = useModalQueryParam(modalQueryParam),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasShareModal = _useModalQueryParam2[0],
    toggleShareModal = _useModalQueryParam2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMenuItem, {
      onClick: toggleShareModal,
      children: t('actions_share')
    }), hasShareModal && /*#__PURE__*/_jsx(ShareContentModal, {
      data: shareData,
      onClose: toggleShareModal
    })]
  });
}
export function GetShareableContentLinkOption(_ref3) {
  var contentId = _ref3.contentId,
    parentPlaylistId = _ref3.parentPlaylistId,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? 'playlist' : _ref3$type,
    _ref3$modalQueryParam = _ref3.modalQueryParam,
    modalQueryParam = _ref3$modalQueryParam === void 0 ? 'share-playlist-link' : _ref3$modalQueryParam;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var _useModalQueryParam3 = useModalQueryParam(modalQueryParam),
    _useModalQueryParam4 = _slicedToArray(_useModalQueryParam3, 2),
    hasShareLinkModal = _useModalQueryParam4[0],
    toggleShareLinkModal = _useModalQueryParam4[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMenuItem, {
      onClick: toggleShareLinkModal,
      children: t('actions_get_shareable_link')
    }), hasShareLinkModal && /*#__PURE__*/_jsx(CopyContentLinkModal, {
      contentId: contentId,
      parentPlaylistId: parentPlaylistId,
      type: type,
      onClose: toggleShareLinkModal
    })]
  });
}
function OpenInOtherAppOption(_ref4) {
  var playlistId = _ref4.playlistId;
  var _useTranslation4 = useTranslation(),
    t = _useTranslation4.t;
  var appNameContext = useAppNameContext();
  if (appNameContext === 'admin') {
    return /*#__PURE__*/_jsx(NavMenuItem, {
      as: "a",
      href: "/playlists/".concat(playlistId),
      target: "_blank",
      children: t('actions_open_in_hub')
    });
  } else {
    return /*#__PURE__*/_jsx(NavMenuItem, {
      as: "a",
      href: "/admin/playlists/".concat(playlistId),
      target: "_blank",
      children: t('actions_open_in_admin_dashboard')
    });
  }
}
function DuplicateOption(_ref5) {
  var playlistId = _ref5.playlistId;
  var _useTranslation5 = useTranslation(),
    t = _useTranslation5.t;
  var history = useHistory();
  var routeMatch = useRouteMatch();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var appNameContext = useAppNameContext();
  var _useDuplicatePlaylist = useDuplicatePlaylists({
      onSuccess: function onSuccess(_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          data = _ref7[0];
        // Redirect to the same page we're currently on, but with the new playlist ID
        var page = getPlaylistPageNumber(data.index);
        var search = appNameContext === 'hub' ? searchParams : _objectSpread(_objectSpread({}, searchParams), {}, {
          page: page
        });
        history.push(createLocation(generatePath(routeMatch.path, {
          playlistId: data.newPlaylistId
        }), search));
      }
    }),
    duplicatePlaylists = _useDuplicatePlaylist.duplicatePlaylists;
  return /*#__PURE__*/_jsx(NavMenuItem, {
    onClick: function onClick() {
      return duplicatePlaylists({
        playlistIds: [playlistId]
      });
    },
    children: t('actions_duplicate')
  });
}
function DeleteOrRestoreOption(_ref8) {
  var playlist = _ref8.playlist,
    onDeletePlaylistSuccess = _ref8.onDeletePlaylistSuccess;
  var _useTranslation6 = useTranslation(),
    t = _useTranslation6.t;
  var history = useHistory();
  var appNameContext = useAppNameContext();
  var location = useLocation();
  var _useModalQueryParam5 = useModalQueryParam('delete-playlist'),
    _useModalQueryParam6 = _slicedToArray(_useModalQueryParam5, 2),
    hasDeletePlaylistModal = _useModalQueryParam6[0],
    toggleDeletePlaylistModal = _useModalQueryParam6[1];
  var _useDeletePlaylist = useDeletePlaylist({
      playlistId: playlist.id,
      onSuccess: function onSuccess() {
        toggleDeletePlaylistModal();
        if (onDeletePlaylistSuccess) {
          onDeletePlaylistSuccess();
        } else {
          var playlistRoute = appNameContext === 'admin' ? '/playlists' : '/browse';
          history.push(playlistRoute);
        }
      }
    }),
    isDeleteLoading = _useDeletePlaylist.isPending,
    deletePlaylist = _useDeletePlaylist.deletePlaylist;
  var _useRestoreContent = useRestoreContent({
      onSuccess: function onSuccess() {
        // Redirect to the same page we're currently on,
        // but with all query parameters removed
        history.push(location.pathname);
      }
    }),
    restoreContent = _useRestoreContent.restoreContent;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [playlist.isDeleted ? /*#__PURE__*/_jsx(NavMenuItem, {
      onClick: function onClick() {
        return restoreContent({
          id: playlist.id,
          type: 'playlist'
        });
      },
      children: t('actions_restore')
    }) : /*#__PURE__*/_jsx(NavMenuItem, {
      onClick: toggleDeletePlaylistModal,
      children: t('actions_delete')
    }), hasDeletePlaylistModal && /*#__PURE__*/_jsx(PlaylistDeleteModal, {
      name: playlist.name,
      ids: [playlist.id],
      isDisabled: isDeleteLoading,
      onClose: toggleDeletePlaylistModal,
      onConfirm: function onConfirm() {
        return deletePlaylist();
      }
    })]
  });
}
export function HeaderOptionsMenu(_ref9) {
  var _ref9$hasDeleteOrRest = _ref9.hasDeleteOrRestoreOption,
    hasDeleteOrRestoreOption = _ref9$hasDeleteOrRest === void 0 ? true : _ref9$hasDeleteOrRest,
    _ref9$hasDuplicateOpt = _ref9.hasDuplicateOption,
    hasDuplicateOption = _ref9$hasDuplicateOpt === void 0 ? true : _ref9$hasDuplicateOpt,
    playlist = _ref9.playlist,
    shareData = _ref9.shareData,
    onDeletePlaylistSuccess = _ref9.onDeletePlaylistSuccess;
  var _useTranslation7 = useTranslation(),
    t = _useTranslation7.t;
  var _useBreakpoints = useBreakpoints('m'),
    isDesktop = _useBreakpoints.m;
  var isPlaylistAdmin = hasPrivilege(PLAYLIST_WRITE);
  var isPlaylistEditable = getIsPlaylistEditable({
    playlist: playlist
  });
  var canUserSharePlaylist = !playlist.isDeleted && canUserShare();
  var hasMenu = isPlaylistEditable || isPlaylistAdmin || canUserSharePlaylist;
  if (!hasMenu) {
    return null;
  }
  var showDuplicateOption = !playlist.isDeleted && isPlaylistAdmin && hasDuplicateOption;
  var showRestoreOrDeleteOption = hasDeleteOrRestoreOption && isPlaylistEditable;
  return /*#__PURE__*/_jsxs(NavMenu, {
    id: "advanced-options-menu",
    menuPlacement: "bottom-end",
    children: [/*#__PURE__*/_jsx(NavMenuButton, {
      variant: "transparent",
      iconRight: "tools",
      iconOnly: !isDesktop,
      children: t('actions_more_options')
    }), /*#__PURE__*/_jsxs(NavMenuList, {
      children: [canUserSharePlaylist && shareData && /*#__PURE__*/_jsx(ShareContentOption, {
        shareData: shareData
      }), canUserSharePlaylist && /*#__PURE__*/_jsx(GetShareableContentLinkOption, {
        contentId: playlist.id
      }), isPlaylistAdmin && /*#__PURE__*/_jsxs(_Fragment, {
        children: [canUserSharePlaylist && /*#__PURE__*/_jsx(NavMenuDivider, {}), /*#__PURE__*/_jsx(ChangelogOption, {
          contentId: playlist.id
        }), !playlist.isDeleted && /*#__PURE__*/_jsx(OpenInOtherAppOption, {
          playlistId: playlist.id
        })]
      }), (showDuplicateOption || showRestoreOrDeleteOption) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(NavMenuDivider, {}), showDuplicateOption && /*#__PURE__*/_jsx(DuplicateOption, {
          playlistId: playlist.id
        }), showRestoreOrDeleteOption && /*#__PURE__*/_jsx(DeleteOrRestoreOption, {
          playlist: playlist,
          onDeletePlaylistSuccess: onDeletePlaylistSuccess
        })]
      })]
    })]
  });
}
export default HeaderOptionsMenu;